
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-btn small color="primary" dark v-bind="attrs" v-on="on"><v-icon left>mdi-pencil</v-icon>Editar</v-btn>
        </div>
      </template>

      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Editando Informações Básicas</div>
        </v-card-title>
        <v-card-text>
          <ModalityInfosForm :modality_infos="main_data" ref="infos_form"></ModalityInfosForm>
        </v-card-text>
        <v-card-actions class="justify-end">
          <f-btn cancel @click="cancelChanges"></f-btn>
          <f-btn save @click="saveInfo"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-loading loadingText="Salvando..." v-if="saving"></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DialogEditMainData',
  components: {
    ModalityInfosForm: () => import('@/_backoffice/_registrations/components/modality/register/ModalityInfosForm.vue'),
  },
  data() {
    return {
      dialog: false,
      saving: false,
      main_data: {},
    }
  },
  mounted () {
    this.main_data = {
      id: this.one_modality.id,
      name: this.one_modality.name,
      corporate_name: this.one_modality.corporate_name,
      document: this.one_modality.document,
      comment: this.one_modality.comment,
      company_pix: this.one_modality.company_pix,
    };
  },
  methods: {
    cancelChanges() {
      this.main_data = {
        id: this.one_modality.id,
        name: this.one_modality.name,
        corporate_name: this.one_modality.corporate_name,
        document: this.one_modality.document,
        comment: this.one_modality.comment,
      }
      this.dialog = false
    },

    saveInfo() {
      const validate = this.$refs.infos_form.validate()
      if (validate) {
        this.swallConfirmation({
          title: 'Deseja atualizar informações do galpão?',
          icon: 'question',
        }).then( confirmed =>{
          if (confirmed ) {
            this.saving = true
            this.saveMainData({data: {...this.main_data, id: this.$route.params.id}}).then(() => {
              this.dialog = false
            }).catch(err => {
              this.saving = true
              console.log(err)
            }).finally(()=>{
              this.saving = false
            })

          }
        })
      }
    },

    ...mapActions({
      saveMainData: 'Modality/update',
    })
  },
  computed: {
    ...mapState({
      one_modality: state => state.Modality.one_modality
    }),
  },
  watch: {
  },
}
</script>

<style scoped>

</style>
